import { createSelector } from "@reduxjs/toolkit";
import { calculatePrices } from "../../utils";
export const selectPrices = createSelector([(state) => state.cart.prices.data, (state) => state.cart.currency], calculatePrices);
//# sourceMappingURL=selectPrices.js.map